export const blogsData = {
  "puppy_proofing": {
    "id": "puppy_proofing",
    "route": "/blogs/puppy-proofing",
    "title": "10 Essential Puppy Proofing Tips from MrigaAayuvets",
    "image": "/images/puppy.jpeg",
    "excerpt": "Create a safe and friendly environment for your new best friend...",
    "author": "Dr. Veterinary Team",
    "date": "March 10, 2024",
    "readTime": "8 min read",
    "category": "Puppy Care"
  },
  "puppy_care": {
    "id": "puppy_care",
    "route": "/blogs/puppy-care",
    "title": "How to take care of your Puppy and feed them?",
    "image": "/images/Maltese.png",
    "excerpt": "The first week of the puppies' lives is the most critical...",
    "author": "Dr. Veterinary Team",
    "date": "March 12, 2024",
    "readTime": "10 min read",
    "category": "Puppy Care"
  },
  "vet_checkups": {
    "id": "vet_checkups",
    "route": "/blogs/vet-checkups",
    "title": "Why Regular Veterinary Checkups are Important",
    "image": "/images/img2.jpg",
    "excerpt": "Routine vet visits ensure your pet's long-term health...",
    "author": "Dr. Veterinary Team",
    "date": "March 14, 2024",
    "readTime": "7 min read",
    "category": "Pet Health"
  },
  "pet_nutrition": {
    "id": "pet_nutrition",
    "route": "/blogs/pet-nutrition",
    "title": "The Ultimate Pet Nutrition Guide",
    "image": "/images/img4.jpg",
    "excerpt": "Learn how to provide a balanced diet for your pet...",
    "author": "Dr. Veterinary Team",
    "date": "March 16, 2024",
    "readTime": "12 min read",
    "category": "Nutrition"
  },
  "dog_training": {
    "id": "dog_training",
    "route": "/blogs/dog-training",
    "title": "Top 5 Dog Training Tips for Beginners",
    "image": "/images/img5.jpg",
    "excerpt": "Training your dog doesn't have to be stressful...",
    "author": "Dr. Veterinary Team",
    "date": "March 18, 2024",
    "readTime": "9 min read",
    "category": "Training"
  },
  "cat_care": {
    "id": "cat_care",
    "route": "/blogs/cat-care",
    "title": "Essential Tips for Keeping Your Cat Happy",
    "image": "/images/img10.jpg",
    "excerpt": "Cats require specific care and attention...",
    "author": "Dr. Veterinary Team",
    "date": "March 20, 2024",
    "readTime": "8 min read",
    "category": "Cat Care"
  },
  "senior_pet_care": {
    "id": "senior_pet_care",
    "route": "/blogs/senior-pet-care",
    "title": "Caring for Senior Pets: What You Need to Know",
    "image": "/images/img6.jpg",
    "excerpt": "Older pets need special care...",
    "author": "Dr. Veterinary Team",
    "date": "March 22, 2024",
    "readTime": "11 min read",
    "category": "Senior Care"
  },
  "dog_breeds": {
    "id": "dog_breeds",
    "route": "/blogs/dog-breeds",
    "title": "Choosing the Right Dog Breed for Your Lifestyle",
    "image": "/images/img8.jpg",
    "excerpt": "Discover which dog breed suits your lifestyle best...",
    "author": "Dr. Veterinary Team",
    "date": "March 24, 2024",
    "readTime": "10 min read",
    "category": "Dog Breeds"
  },
  "pet_emergencies": {
    "id": "pet_emergencies",
    "route": "/blogs/pet-emergencies",
    "title": "How to Handle Pet Emergencies",
    "image": "/images/img11.jpg",
    "excerpt": "Knowing how to act in an emergency can save your pet's life...",
    "author": "Dr. Veterinary Team",
    "date": "March 26, 2024",
    "readTime": "15 min read",
    "category": "Emergency Care"
  }
};



export const servicesData = {
  "vaccination": {
    "id": "vaccination",
    "route": "/services/vaccination",
    "title": "Pet Vaccination Services",
    "image": "/images/imgs1.png",
    "description": "Comprehensive vaccination services for dogs, cats, and other pets. Core and non-core vaccines available with expert guidance.",
    "details": "We provide comprehensive vaccination services for dogs, cats, and other pets in the comfort of your home. Our experienced veterinarians follow the latest vaccination protocols recommended by veterinary associations.",
    "benefits": [
      "Convenient at-home service reducing stress",
      "Core vaccines: Rabies, DHPP/FVRCP",
      "Non-core vaccines based on lifestyle",
      "Expert veterinary guidance and monitoring",
      "Vaccination record maintenance",
      "Booster reminders and scheduling"
    ],
    "pricing": "Starting from ₹300 per vaccine"
  },
  "general_treatment": {
    "id": "general_treatment",
    "route": "/services/general-treatment",
    "title": "General Pet Treatment",
    "image": "/images/imgs2.jpg",
    "description": "Comprehensive general treatment services covering common health issues, medications, and follow-up care.",
    "details": "Our general treatment services cover a wide range of common pet health issues including respiratory problems, digestive issues, skin conditions, and more.",
    "benefits": [
      "Complete physical examination",
      "Treatment for common ailments",
      "Medication prescription and guidance",
      "Health monitoring and follow-up",
      "Home visit convenience",
      "Personalized treatment plans"
    ],
    "pricing": "Consultation from ₹300, Treatment varies"
  },
  "deworming": {
    "id": "deworming",
    "route": "/services/deworming",
    "title": "Pet Deworming Services",
    "image": "/images/imgs3.jpg",
    "description": "Professional deworming services with fecal analysis to keep your pets parasite-free and healthy.",
    "details": "Internal parasites are common in pets and can cause serious health problems if left untreated. Our deworming service includes fecal examination and customized treatment.",
    "benefits": [
      "Fecal analysis for accurate diagnosis",
      "Safe, effective broad-spectrum dewormers",
      "Customized treatment schedules",
      "Prevention of zoonotic transmission",
      "Regular monitoring and follow-up",
      "Education on parasite prevention"
    ],
    "pricing": "Fecal test ₹200-₹500, Deworming ₹50-₹500"
  },
  "grooming": {
    "id": "grooming",
    "route": "/services/pet-grooming",
    "title": "Professional Pet Grooming",
    "image": "/images/imgs4.jpg",
    "description": "Complete grooming services including bathing, hair trimming, brushing, and styling at your home.",
    "details": "Regular grooming is essential for your pet's health and comfort. Our professional groomers provide complete grooming services in the stress-free environment of your home.",
    "benefits": [
      "Complete grooming packages available",
      "Bathing with pet-safe products",
      "Hair trimming and styling",
      "Nail trimming and ear cleaning",
      "De-shedding treatments",
      "Stress-free home environment"
    ],
    "pricing": "Small dogs ₹800-₹1,500, Large dogs ₹1,200-₹2,500"
  },
  "nail_trimming": {
    "id": "nail_trimming",
    "route": "/services/nail-trimming",
    "title": "Professional Nail Trimming",
    "image": "/images/nail.jpeg",
    "description": "Expert nail care services to keep your pet comfortable, prevent injuries, and maintain proper posture.",
    "details": "Regular nail trimming is crucial for your pet's comfort and health. Overgrown nails can cause pain, affect gait, and lead to injuries.",
    "benefits": [
      "Professional trimming technique",
      "Prevents pain and discomfort",
      "Maintains proper gait and posture",
      "Reduces scratching damage",
      "Home service reduces anxiety",
      "Quick identification safety"
    ],
    "pricing": "Small pets ₹150-₹300, Large pets ₹200-₹400"
  },
  "dental_care": {
    "id": "dental_care",
    "route": "/services/dental-care",
    "title": "Pet Dental Care",
    "image": "/images/imgs6.jpg",
    "description": "Comprehensive dental health services including examinations, cleaning, and disease prevention.",
    "details": "Dental health is crucial for your pet's overall wellbeing. We provide comprehensive dental care services to prevent and treat oral health issues.",
    "benefits": [
      "Oral examinations and assessments",
      "Professional dental cleaning",
      "Early disease detection",
      "Home dental care guidance",
      "Dental product recommendations",
      "Pain management for dental issues"
    ],
    "pricing": "Basic cleaning ₹3,000-₹8,000, Advanced ₹8,000+"
  },
  "pet_xray": {
    "id": "pet_xray",
    "route": "/services/xray-imaging",
    "title": "Mobile Pet X-Ray Services",
    "image": "/images/imgs7.jpg",
    "description": "Advanced diagnostic imaging services with digital X-ray technology at your doorstep.",
    "details": "Our mobile X-ray service brings advanced diagnostic capabilities directly to your home, reducing stress for your pet while providing accurate diagnostic imaging.",
    "benefits": [
      "Convenient home service",
      "Advanced digital X-ray technology",
      "Quick, non-invasive procedure",
      "Instant image availability",
      "Bone and organ visualization",
      "Expert radiological interpretation"
    ],
    "pricing": "Basic X-rays ₹1,500-₹3,000, Specialized ₹3,500+"
  },
  "emergency_care": {
    "id": "emergency_care",
    "route": "/services/emergency-care",
    "title": "Emergency Pet Care",
    "image": "/images/imgs8.jpg",
    "description": "Immediate veterinary response for urgent situations. Available with experienced emergency veterinarians.",
    "details": "Pet emergencies can happen at any time. Our emergency service ensures immediate veterinary care is available when your pet needs it most.",
    "benefits": [
      "Availability every day",
      "Rapid response time",
      "Experienced emergency veterinarians",
      "Life-saving interventions",
      "Critical care equipment",
      "Stabilization and transport support"
    ],
    "pricing": "Emergency consultation varies, call immediately"
  },
  "nutrition_guidance": {
    "id": "nutrition_guidance",
    "route": "/services/nutrition-guidance",
    "title": "Pet Nutrition Consultation",
    "image": "/images/imgs9.jpg",
    "description": "Personalized nutrition plans tailored to your pet's age, breed, health status, and lifestyle.",
    "details": "Proper nutrition is fundamental to your pet's health and longevity. Our nutrition experts create customized dietary plans for optimal health.",
    "benefits": [
      "Personalized meal plans",
      "Weight management support",
      "Life stage appropriate nutrition",
      "Breed-specific recommendations",
      "Evidence-based dietary advice",
      "Supplement guidance"
    ],
    "pricing": "Consultation ₹1000-₹1,500"
  }
};


export const galleryImages = [
  { id: 1, image_path: 'gall1.jpeg', uploaded_at: '2024-01-01', alt: 'Happy pet receiving care' },
  { id: 2, image_path: 'gall2.jpeg', uploaded_at: '2024-01-02', alt: 'Veterinary examination' },
  { id: 3, image_path: 'gall3.jpeg', uploaded_at: '2024-01-03', alt: 'Pet vaccination service' },
  { id: 4, image_path: 'gall4.jpeg', uploaded_at: '2024-01-04', alt: 'Grooming session' },
  { id: 5, image_path: 'gall5.jpeg', uploaded_at: '2024-01-05', alt: 'Pet dental care' },
  { id: 6, image_path: 'gall6.jpeg', uploaded_at: '2024-01-06', alt: 'Emergency care' },
  { id: 7, image_path: 'gall7.jpeg', uploaded_at: '2024-01-07', alt: 'Nutrition consultation' },
  { id: 8, image_path: 'gall8.jpeg', uploaded_at: '2024-01-08', alt: 'X-ray imaging' },
  { id: 9, image_path: 'gall9.jpeg', uploaded_at: '2024-01-09', alt: 'Nail trimming service' },
  { id: 10, image_path: 'gall10.jpeg', uploaded_at: '2024-01-10', alt: 'Deworming treatment' },
  { id: 11, image_path: 'gall11.jpeg', uploaded_at: '2024-01-11', alt: 'General checkup' },
  { id: 12, image_path: 'gall12.jpeg', uploaded_at: '2024-01-12', alt: 'Pet with veterinarian' },
  { id: 13, image_path: 'gall13.jpeg', uploaded_at: '2024-01-13', alt: 'Home visit service' },
  { id: 14, image_path: 'gall14.jpeg', uploaded_at: '2024-01-14', alt: 'Happy pet owner' },
  { id: 15, image_path: 'gall15.jpeg', uploaded_at: '2024-01-15', alt: 'Professional care' },
  { id: 16, image_path: 'gall16.jpeg', uploaded_at: '2024-01-16', alt: 'Pet treatment' },
  { id: 17, image_path: 'gall17.jpeg', uploaded_at: '2024-01-17', alt: 'Veterinary team' },
  { id: 18, image_path: 'gall18.jpeg', uploaded_at: '2024-01-18', alt: 'Pet health check' },
  { id: 19, image_path: 'gall19.jpeg', uploaded_at: '2024-01-19', alt: 'Home service' },
  { id: 20, image_path: 'gall20.jpeg', uploaded_at: '2024-01-20', alt: 'Pet care excellence' }
];

// Contact Information
export const contactInfo = {
  phone: "+91 82086 57969",
  email: "Mrigaayuvets2025@gmail.com",
  whatsapp: "918208657969",
  location: "Mumbai, Maharashtra, India",
  hours: {
    weekdays: "9:00 AM - 8:00 PM",
    weekends: "10:00 AM - 6:00 PM",
    emergency: "Available Now"
  }
};

// Social Media Links
export const socialMedia = {
  facebook: "https://facebook.com/mrigaayuvets",
  instagram: "https://instagram.com/mrigaayuvets",
  twitter: "https://twitter.com/mrigaayuvets",
  youtube: "https://youtube.com/@mrigaayuvets"
};

// Statistics
export const statistics = {
  happyClients: "1500+",
  servicesProvided: "3000+",
  yearsExperience: "5+",
  teamMembers: "10+"
};
